import { useTranslation } from '#app/utils/i18n.ts'

export default function ApplyDone() {
	const t = useTranslation()
	return (
		<main className="container flex min-h-full flex-col items-center justify-center py-16">
			<p className="text-body-lg max-w-md text-center">{t('apply.success')}</p>
		</main>
	)
}
